import Vue from 'vue'
import request from "./config/http.js"
import params from "./config/params.js"






const apis = {




}


export default apis



// WEBPACK FOOTER //
// ./src/core/api/index.serve.js